import { whatsappChatUrl } from "@/lib/whatsapp";

type Props = {
  title: string;
  description: string;
  prefilledMessage: string;
  buttonLabel?: string;
  className?: string;
};

export function WhatsAppContactCard({
  title,
  description,
  prefilledMessage,
  buttonLabel = "Contact via WhatsApp",
  className = "",
}: Props) {
  const href = whatsappChatUrl(prefilledMessage);

  return (
    <div
      className={[
        "rounded-2xl border border-emerald-200/90 bg-emerald-50/50 p-6 shadow-sm",
        className,
      ].join(" ")}
    >
      <h2 className="font-display text-lg font-bold text-brand-blue">{title}</h2>
      <p className="mt-3 text-sm leading-relaxed text-brand-blue/85">
        {description}
      </p>
      <p className="mt-2 text-sm text-brand-blue/70">
        Official WhatsApp:{" "}
        <span className="font-semibold text-brand-blue">+94 76 684 5050</span>
      </p>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-5 inline-flex items-center justify-center rounded-xl bg-[#25D366] px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-[#20bd5a] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-blue"
      >
        {buttonLabel}
      </a>
    </div>
  );
}
